import { useTranslation } from "react-i18next";

export default function Subsidie() {
  const { t } = useTranslation("home");

  return (
    <section className="bg-brand-yellow w-full">
      <div className="max-w-[1400px] mx-auto px-4 md:px-10 py-16 md:py-[100px] flex flex-col md:flex-row items-center gap-10 md:gap-[60px]">
        <div className="w-full md:w-[55%]">
          <h2 className="font-geist font-bold text-3xl md:text-[48px] text-brand-text leading-tight mb-6">
            {t("subsidie.h2")}
          </h2>
          <p className="font-geist text-base md:text-lg text-brand-text/85 max-w-[520px] leading-relaxed mb-8">
            {t("subsidie.body")}
          </p>
          <a
            href="/blog/isde-subsidie-2026/"
            className="inline-flex font-geist font-bold text-sm md:text-base bg-brand-text text-white px-7 py-3.5 rounded-full hover:bg-white hover:text-brand-text transition-colors whitespace-nowrap"
          >
            {t("subsidie.cta")}
          </a>
        </div>
        <div className="w-full md:w-[45%] flex items-center justify-center">
          <img
            src="/img/69-technical-cross-section-illustration.jpg"
            alt="HR++ glas doorsnede illustratie — isolerend dubbelglas techniek"
            className="w-full max-w-[480px] rounded-2xl"
          />
        </div>
      </div>
    </section>
  );
}